import { FormControl } from "@angular/forms";

export const ipRegex = /^([0-9]{1,3}[.]){3,}[0-9]{1,3}$/; // NOSONAR
export const ipValid = (control: FormControl) => {
    const value = control.value || "";
    const errors = { invalidIP: null, minLength: null };
    if (!ipRegex.test(value)) {
        errors.invalidIP = `Please enter a valid ip address(ex: 0.0.0.0)`;
    }

    return Object.values(errors).some(val => !!val) ? errors : null;
};
